import { render, staticRenderFns } from "./usersAccessHistory.vue?vue&type=template&id=45f395da&scoped=true&"
import script from "./usersAccessHistory.vue?vue&type=script&lang=js&"
export * from "./usersAccessHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f395da",
  null
  
)

export default component.exports